import { Dropdown, Space, Tag } from 'antd'
import { DownOutlined, EditOutlined } from '@ant-design/icons'
import { isValidArray } from '../../../../../sprints/components/testReport/testCases/forms/helper'

export const getColumns = (onAction) => {
    const statusColors = {
        Pending: 'orange',
        Pass: 'green',
        Passed: 'green',
        Fail: 'red',
        Retest: 'blue',
    }

    const columns = [
        { title: 'ID', dataIndex: 'testId', width: 130 },
        {
            title: 'Title',
            dataIndex: 'title',
            // maxWidth: 350,
            // width: 350,
            // ellipsis: true,
        },

        {
            title: 'Status',
            dataIndex: 'status',
            maxWidth: 100,
            render: (status) => (
                <Tag
                    color={statusColors[status] || 'default'}
                    key={status}
                    style={{ fontSize: 13, padding: '3px' }}
                >
                    {status}
                </Tag>
            ),
        },
        {
            title: 'Sprint',
            dataIndex: 'sprint',
            width: 150,
            render: (sprint) => <span>{sprint?.title || 'N/A'}</span>,
        },
        // {
        //     title: 'Epic',
        //     dataIndex: 'epic',
        //     width: 150,
        //     render: (epic) => <span>{epic?.title || 'N/A'}</span>,
        // },
        {
            title: 'Tags',
            dataIndex: 'tags',
            width: 300,
            render: (tags) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        flexWrap: 'wrap',
                        rowGap: 4,
                    }}
                >
                    {isValidArray(tags)
                        ? tags?.map((tag) => {
                              return (
                                  <Tag
                                      color={'purple'}
                                      key={tag}
                                      style={{ fontSize: 9, padding: '3px' }}
                                  >
                                      {tag?.name || 'N/A'}
                                  </Tag>
                              )
                          })
                        : 'N/A'}
                </div>
            ),
        },

        {
            title: 'Action',
            key: 'action',
            width: 100,
            render: (_text, record) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <EditOutlined
                        title="Edit"
                        onClick={() => onAction('single', record._id)}
                    />
                </div>
            ),
        },
    ]

    return columns
}
